import { useState } from "react";
import { Typography, Box } from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import CustomPagination from "../../components/CustomPagination";
import { toMoney } from "../../util/Utils";
import ReportProblemRoundedIcon from "@mui/icons-material/ReportProblemRounded";
import RedeemIcon from "@mui/icons-material/Redeem";

export default function OrdersListGrid(props) {
  const [ordersRes, setOrdersRes] = useState(props.rows ? props.rows : []);

  const columns = [
    {
      field: "id",
      width: 70,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
      // hide: true,
      sortable: false,
    },
    {
      field: "productID",
      width: 100,
      align: "center",
      headerName: "کد محصول",
      headerAlign: "center",
      sortable: false,
      renderCell: (cellValues) => {
        return (
          <Box
            sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
            onClick={() => window.open(cellValues.row.productURL, "_blank")}
          >
            <Typography variant="span" sx={{ whiteSpace: "normal", ml: 1 }}>
              {cellValues.row.productID}
            </Typography>
          </Box>
        );
      },
    },
    {
      field: "productName",
      headerName: "نام محصول",
      width: 400,
      align: "left",
      headerAlign: "center",
      sortable: false,
      renderCell: (cellValues) => {
        return (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            {cellValues.row.checkCost && (
              <ReportProblemRoundedIcon fontSize="small" color="warning" />
            )}
            {cellValues.row.isGift && (
              <RedeemIcon sx={{ ml: 1 }} fontSize="small" color="secondary" />
            )}
            <Typography variant="span" sx={{ whiteSpace: "normal", ml: 1 }}>
              {cellValues.row.productName}
            </Typography>
          </Box>
        );
      },
    },
    {
      field: "orderCount",
      headerName: "تعداد سفارش",
      width: 100,
      align: "center",
      headerAlign: "center",
      sortable: false,
    },
    {
      field: "cost",
      headerName: "قیمت",
      width: 120,
      align: "center",
      headerAlign: "center",
      sortable: false,
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.cost ? toMoney(cellValues.row.cost) : 0}
          </Typography>
        );
      },
    },
    {
      field: "discountCost",
      headerName: "قیمت با تخفیف",
      width: 120,
      align: "center",
      headerAlign: "center",
      sortable: false,
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.discountCost
              ? toMoney(cellValues.row.discountCost)
              : 0}
          </Typography>
        );
      },
    },
  ];

  return (
    <Box sx={{ height: "25rem" }}>
      {ordersRes && (
        <DataGrid
          className="ltr-grid"
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          pageSize={100}
          rows={ordersRes}
          page={0}
          rowCount={ordersRes && ordersRes.length ? ordersRes.length : 1}
          enableRangeSelection={true}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
          }}
          componentsProps={{
            pagination: {
              isLtr: true,
              nofab: true,
              // noPage: true,
              rowCount: ordersRes && ordersRes.length ? ordersRes.length : "",
            },
          }}
        />
      )}
    </Box>
  );
}
